import { render } from "./NavigationHeader.vue?vue&type=template&id=0225a3c3&scoped=true"
import script from "./NavigationHeader.vue?vue&type=script&lang=js"
export * from "./NavigationHeader.vue?vue&type=script&lang=js"

import "./NavigationHeader.vue?vue&type=style&index=0&id=0225a3c3&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225a3c3"]])

export default __exports__